import toast from 'react-hot-toast';
import { ApiError } from 'services/openapi/core/ApiError';

const requestErrors = new WeakSet<object>();

export const isRequestError = (error: unknown): boolean =>
  error instanceof ApiError ||
  (typeof error === 'object' && error !== null && requestErrors.has(error));

/** Notify once per failed request; callers can still handle local failures. */
export const notifyRequestError = (error: unknown): void => {
  if (typeof error === 'object' && error !== null) {
    if (requestErrors.has(error)) return;
    requestErrors.add(error);
  }

  if (error instanceof Error && error.name === 'AbortError') return;

  const apiMessage =
    error instanceof ApiError ? error.body?.message : undefined;
  const messages = (Array.isArray(apiMessage) ? apiMessage : [apiMessage])
    .filter((message): message is string => typeof message === 'string')
    .map((message) => message.trim())
    .filter(Boolean);

  toast.error(
    Array.from(new Set(messages)).join('\n') ||
      (error instanceof ApiError ? error.message : '') ||
      'Không thể kết nối máy chủ, vui lòng thử lại sau!',
  );
};
